/* flag-group.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(max-width%3A560px)%7B._1iafidpf%7Binset-block-end%3A0%7D._il0widpf%7Binset-inline-start%3A0%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e021epz%7Binset-inline-start%3Avar(--ds-space-1000%2C5pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u7cooahv%7Binset-block-end%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbyxejw%7Bz-index%3Aflag%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqsw1n9t%7Bposition%3Afixed%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12a7luct._12a7luct%2B*%7Btransition-duration%3A175ms%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._t9ec1hw2%7Btransform%3AtranslateX(0)%20translateY(100%25)%20translateY(1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5sag5cps%7Banimation-duration%3A0ms%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v564glyw%7Btransition%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v5641b8g%7Btransition%3Atransform%20.35s%20ease-in-out%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3um015vq%7Bvisibility%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._t9ec15wd%7Btransform%3AtranslateY(200%25)%20translateY(2pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbyegat%7Bz-index%3A4%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._t9ec1pi4%7Btransform%3AtranslateY(100%25)%20translateY(1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbyqfx8%7Bz-index%3A5%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._t9ec1ygq%7Btransform%3Atranslate(0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(max-width%3A560px)%7B._1eqkauwl%7Bwidth%3A100vw%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1kdj%7Bwidth%3A25pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u7coidpf%7Binset-block-end%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v564t8bh%7Btransition%3Avar(--ds-flag-reposition%2Ctransform%20.25s%20cubic-bezier(.4%2C0%2C0%2C1))%7D");
import { Children, createContext, type ReactElement, useContext, useEffect, useMemo, useRef } from 'react';
import { bind } from 'bind-event-listener';
import { type UIAnalyticsEvent, useAnalyticsEvents } from '@atlaskit/analytics-next';
import { getDocument } from '@atlaskit/browser-apis';
import { cx } from '@atlaskit/css';
import noop from '@atlaskit/ds-lib/noop';
import { ExitingPersistence, SlideIn, Motion } from '@atlaskit/motion';
import { fg } from '@atlaskit/platform-feature-flags';
import Portal from '@atlaskit/portal';
import { Box } from '@atlaskit/primitives/compiled';
import { layers } from '@atlaskit/theme/constants';
import VisuallyHidden from '@atlaskit/visually-hidden';
type FlagGroupProps = {
  /**
   * ID attribute used for DOM selection.
   */
  id?: string;
  /**
   * Describes the specific role of this FlagGroup for users viewing the page with a screen reader (defaults to `Flag notifications`).
   */
  label?: string;
  /**
   * Describes the specific tag on which the screen reader text will be rendered (defaults to `h2`).
   */
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  labelTag?: React.ElementType;
  /**
   * Flag elements to be displayed.
   */
  children?: Array<ReactElement> | ReactElement | null | boolean;
  /**
   * Handler which will be called when a Flag's dismiss button is clicked.
   * Receives the id of the dismissed Flag as a parameter.
   */
  onDismissed?: (id: number | string, analyticsEvent: UIAnalyticsEvent) => void;
  /**
   * Controls whether the flag group is rendered inline within its parent component or in a portal at the document root.
   * `true` renders the flag group in the DOM node closest to the trigger
   * `false` renders the flag group in React.Portal
   * Defaults to `false`.
   */
  shouldRenderToParent?: boolean;
};
export const flagWidth = 400;
type FlagGroupAPI = {
  onDismissed: (id: number | string, analyticsEvent: UIAnalyticsEvent) => void;
  isDismissAllowed: boolean;
};
const defaultFlagGroupContext = {
  onDismissed: noop,
  isDismissAllowed: false
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const FlagGroupContext: import('react').Context<FlagGroupAPI> = createContext<FlagGroupAPI>(defaultFlagGroupContext);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export function useFlagGroup(): FlagGroupAPI {
  return useContext(FlagGroupContext);
}

// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const groupStyles = {
  root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
  first: "_v564glyw _t9ec1ygq _1pbyqfx8",
  second: "_1pbyegat",
  nth: "_5sag5cps _t9ec1hw2",
  hidden: "_3um015vq"
};

// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const groupStylesNew = {
  root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
  first: "_t9ec1ygq _1pbyqfx8",
  second: "_t9ec1pi4 _1pbyegat",
  nth: "_t9ec15wd",
  hidden: "_3um015vq"
};

// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const dismissAllowedStyles = null;
const flagGroupContainerStyles = null;

/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */
const FlagGroup = (props: FlagGroupProps): JSX.Element => {
  const {
    id,
    label = 'Flag notifications',
    labelTag: LabelTag = 'h2',
    shouldRenderToParent = false,
    children,
    onDismissed = noop
  } = props;
  const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
  const dismissFlagContext: FlagGroupAPI = useMemo(() => ({
    onDismissed: onDismissed,
    isDismissAllowed: true
  }), [onDismissed]);

  // Keep a stable reference to the latest children, dismiss handler, and
  // analytics creator so the keydown listener never reads stale closures.
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const latestRef = useRef<{
    children: FlagGroupProps['children'];
    onDismissed: FlagGroupProps['onDismissed'];
    createAnalyticsEvent: typeof createAnalyticsEvent;
  }>({
    children,
    onDismissed,
    createAnalyticsEvent
  });
  latestRef.current = {
    children,
    onDismissed,
    createAnalyticsEvent
  };

  // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
  // technology users to dismiss the topmost (and only dismissable) flag with
  // the Escape key, without having to tab through the entire page to reach
  // the dismiss button. Behaviour is gated behind a feature flag so it can
  // be rolled out and validated incrementally.
  useEffect(() => {
    if (!fg('platform_dst_flag_keyboard_dismiss')) {
      return;
    }
    if (!hasFlags) {
      return;
    }
    const doc = getDocument();
    if (!doc) {
      return;
    }
    return bind(doc, {
      type: 'keydown',
      listener: (event: KeyboardEvent) => {
        if (event.key !== 'Escape' || event.defaultPrevented) {
          return;
        }
        const currentChildren = latestRef.current.children;
        const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
        if (!firstFlag || typeof firstFlag !== 'object') {
          return;
        }
        const id = (firstFlag as ReactElement).props?.id;
        if (id === undefined || id === null || id === '') {
          return;
        }
        const analyticsEvent = latestRef.current.createAnalyticsEvent({
          action: 'dismissed',
          actionSubject: 'flag',
          attributes: {
            dismissedVia: 'keyboardShortcut',
            key: 'Escape'
          }
        });
        event.preventDefault();
        latestRef.current.onDismissed?.(id, analyticsEvent);
      }
    });
  }, [hasFlags]);
  const renderChildren = () => {
    return children && typeof children === 'object' ? Children.map(children, (flag: ReactElement, index: number) => {
      const isDismissAllowed = index === 0;
      return fg('platform-dst-motion-uplift') ? <Box xcss={cx(groupStylesNew.root, index === 0 && groupStylesNew.first, index === 1 && groupStylesNew.second, index >= 2 && groupStylesNew.nth, index >= 3 && groupStylesNew.hidden)} data-vc-oob>
							<Motion enteringAnimation={"var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)"} exitingAnimation={"var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"}>
								<FlagGroupContext.Provider value={
          // Only the first flag should be able to be dismissed.
          isDismissAllowed ? dismissFlagContext : defaultFlagGroupContext}>
									{flag}
								</FlagGroupContext.Provider>
							</Motion>
						</Box> : <SlideIn enterFrom="left" fade="inout" duration="medium" animationTimingFunction="ease-in">
							{({
          className,
          ref
        }) => <div
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className={ax([groupStyles.root, index === 0 && groupStyles.first, index === 1 && groupStyles.second, index >= 1 && groupStyles.nth, index >= 2 && groupStyles.hidden, isDismissAllowed && "_12a7luct", className])} ref={ref} data-vc-oob>
									<FlagGroupContext.Provider value={
          // Only the first flag should be able to be dismissed.
          isDismissAllowed ? dismissFlagContext : defaultFlagGroupContext}>
										{flag}
									</FlagGroupContext.Provider>
								</div>}
						</SlideIn>;
    }) : false;
  };
  const isKeyboardDismissEnabled = fg('platform_dst_flag_keyboard_dismiss');
  // When the keyboard dismiss shortcut is available, surface it to assistive
  // technology users via the existing visually-hidden landmark heading so they
  // know they can press Escape to dismiss the topmost flag.
  const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
  const flags = <div id={id} data-vc-oob className={ax(["_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"])}>
			{hasFlags ? <VisuallyHidden>
					{/* @ts-ignore - TS2604/TS2786: LabelTag type union causing issues for help-center local consumption with TS 5.9.2 */}
					<LabelTag>{screenReaderLabel}</LabelTag>
				</VisuallyHidden> : null}

			<ExitingPersistence appear={false}>{renderChildren()}</ExitingPersistence>
		</div>;
  return shouldRenderToParent ? flags : <Portal zIndex={layers.flag()}>{flags}</Portal>;
};
export default FlagGroup;